import React, { useRef } from "react";
import { Box, Button, IconButton, Img, Input } from "@chakra-ui/react";
import { AiOutlineClose } from "react-icons/ai";
import { BiUpload } from "react-icons/bi";

interface GaraazMediaUploaderProps {
    handleDeleteProfilePicture: () => void;
    handleMediaInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    allowMimeType?: string;
    mediaSrc?: string;
    isMediaDeleting?: boolean;
    isMediaUploading?: boolean;
    containerStyle?:React.CSSProperties;
    imageStyle?: React.CSSProperties;
}

const GaraazMediaUploader: React.FC<GaraazMediaUploaderProps> = ({
    handleDeleteProfilePicture,
    handleMediaInputChange,
    allowMimeType = "image/*",
    mediaSrc,
    isMediaDeleting = false,
    isMediaUploading = false,
    containerStyle={height :"250px"},
    imageStyle={height :"85%", width:"100%"}
}) => {
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const handleAddMediaClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <Box position="relative" style={{...containerStyle}}>
            <Img
                src={
                    mediaSrc ??
                    "https://media.istockphoto.com/id/1451587807/vector/user-profile-icon-vector-avatar-or-person-icon-profile-picture-portrait-symbol-vector.jpg?s=612x612&w=0&k=20&c=yDJ4ITX1cHMh25Lt1vI1zBn2cAKKAlByHBvPJ8gEiIg="
                }
                alt="Profile picture"
                style={{...imageStyle}}
            />
            {mediaSrc && (
                <IconButton
                    h="25px"
                    aria-label="Delete Profile"
                    isLoading={isMediaDeleting}
                    position="absolute"
                    top={0}
                    right={0}
                    onClick={handleDeleteProfilePicture}
                    p={0}
                    icon={<AiOutlineClose />}
                />
            )}
            <Input
                type="file"
                ref={fileInputRef}
                accept={allowMimeType}
                style={{ display: "none" }}
                onChange={handleMediaInputChange}
            />
            <Button
                h="15%"
                zIndex={1}
                isLoading={isMediaUploading}
                onClick={handleAddMediaClick}
                borderTopRadius={0}
                padding="4px 0"
                aria-label="Upload Media"
                w={"100%"}
                position={"absolute"}
                bottom={0}
                left={0}
            >
                <BiUpload size="25px" />
            </Button>
        </Box>
    );
};

export default GaraazMediaUploader;
